import { UserService } from 'src/app/services/user/user.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { NotificationService } from 'src/app/services/notification/notification.service';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
@Component({
  selector: 'app-enterprise-notification-user-modal',
  templateUrl: './enterprise-notification-user-modal.component.html',
  styleUrls: ['./enterprise-notification-user-modal.component.css'],
})
export class EnterpriseNotificationUserModalComponent implements OnInit {
  users: any[];
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  color1: string;
  color2: string;
  loading: boolean = false;
  title: string;
  idEnterprise: number;
  idUser: number;
  selectedUser = 0;
  inputEmail = '';
  inputUser = '';
  inputPhone = '';
  email = '';
  user = '';
  phone = '';
  headquarters: any[] = [];
  selectedHeadquarterIds: number[] = [];
  allHeadquartersSelected: boolean = true;
  
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<EnterpriseNotificationUserModalComponent>,
    private userService: UserService,
    private notificationService: NotificationService,
    private headquarterService: HeadquarterService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    // console.log(this.alert);
    this.title = AppConstants.TitleModal.ADD_NEW_EMAIL_FOR_ALERT;
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.enterpriseSelect = +localStorage.getItem(
      AppConstants.Session.ENTERPRISE
    );
 
    this.userList();
    this.getHeadquarters();

    // Si es edición, setea los valores
    if (this.data.user) {
      // Si el usuario es de la lista, selecciona el usuario
      if (this.data.user.idUser) {
        this.selectedUser = this.data.user.idUser;
      }else{
        // Si es usuario manual, setea los campos de texto
        if (this.data.user.user) {
          this.inputUser = this.data.user.user;
          this.user = this.data.user.user;
        }
        if (this.data.user.email) {
          this.inputEmail = this.data.user.email;
          this.email = this.data.user.email;
        }
        if (this.data.user.phone) {
          this.inputPhone = this.data.user.phone;
          this.phone = this.data.user.phone;
        }
      }
    }
  }

  //LLENAMOS EL CORREO
  onUserSelect(event: any) {
    if (event.target.value) {
      this.inputEmail = '';
      this.inputPhone = '';
      this.inputUser = '';
      this.selectedUser = event.target.value;
    }
  }
  onUserInput(event: any) {
    if (event.target.value) {
      this.selectedUser = 0;
      this.user = event.target.value;
      console.log(this.email);
    }
  }
  onPhoneInput(event: any) {
    if (event.target.value) {
      this.selectedUser = 0;
      this.phone = (event.target.value).trim();
      console.log(this.email);
    }
  }
  onEmailInput(event: any) {
    if (event.target.value) {
      this.selectedUser = 0;
      this.email = event.target.value;
      console.log(this.email);
    }
  }

  // TRAEMOS LOS USUARIOS DE LA SEDE
  userList() {
    this.users = [];
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
    };
    this.spinner.show();
    this.userService.getUserEnterpriseHeadquarters(filter).subscribe(
      (response) => {
        if (response.error == null) {
          this.users = response.data;
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  getHeadquarters() {
      this.headquarterService.getListAll().subscribe((response) => {
        if(response.error == null){
          this.headquarters = response.data.filter(f => f.idEnterprise == this.enterpriseSelect);
          if(this.headquarters.length > 0){
            this.headquarterSelect = 0;
            this.selectedHeadquarterIds = this.headquarters.map(hq => hq.id);
            this.headquarters.forEach(hq => hq.selected = true);
            this.allHeadquartersSelected = true;
          }

          // Sedes seleccionadas
          if (this.data.user && this.data.user.headquarters) {
            let hqIds: number[] = [];
            if (Array.isArray(this.data.user.headquarters)) {
              hqIds = this.data.user.headquarters.map(Number);
            } else if (typeof this.data.user.headquarters === 'string') {
              hqIds = this.data.user.headquarters.split(',').map(Number);
            } else if (typeof this.data.user.headquarters === 'number') {
              hqIds = [this.data.user.headquarters];
            }
            this.selectedHeadquarterIds = hqIds;

            this.headquarters.forEach(hq => {
              hq.selected = this.selectedHeadquarterIds.indexOf(hq.id) !== -1;
            });
            this.allHeadquartersSelected = this.headquarters.every(hq => hq.selected);
          }
        }else{
          this.headquarters = [];
        }
        this.spinner.hide();
      },
        (error: HttpErrorResponse) => {
          this.headquarters = [];
        });
  }

  onHeadquarterCheckChange(hq: any) {
    if (hq.selected) {
      if (this.selectedHeadquarterIds.indexOf(hq.id) === -1) {
        this.selectedHeadquarterIds.push(hq.id);
      }
    } else {
      this.selectedHeadquarterIds = this.selectedHeadquarterIds.filter(id => id !== hq.id);
    }
    this.allHeadquartersSelected = this.headquarters.every(hq => hq.selected);
  }

  toggleAllHeadquarters() {
    if (this.allHeadquartersSelected) {
      this.headquarters.forEach(hq => hq.selected = true);
      this.selectedHeadquarterIds = this.headquarters.map(hq => hq.id);
    } else {
      this.headquarters.forEach(hq => hq.selected = false);
      this.selectedHeadquarterIds = [];
    }
  }

  //AGREGAMOS EL EMAIL PARA ALERTAS
  save() {

    var payload = {
      idEnterpriseNotification: this.data.alert.id ,
      idUser: this.selectedUser,
      idEnterprise: this.idEnterprise,
      idAlertType: this.data.alert.idAlertType,
      email: this.email,
      phone: this.phone ? String(this.phone).replace(/\s+/g, '') : '',
      user: this.user,
      headquarters: this.selectedHeadquarterIds.join(',')
    };

    if(this.data.user != null && this.data.user != undefined){
      var p = {
        ...payload,
        id: this.data.user.id
      }
      this.notificationService
      .updateEnterpriseSettingUser(p)
      .subscribe(
        (response) => {
          if(response.code == 200){
            this.alertService.showMessage(
              response.message,
              "",
              MessageSeverity.success
            );
            this.dialogRef.close({add:true});
            
          }else{
            this.alertService.showMessage(
              response.message,
              "",
              MessageSeverity.error
            );
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }else{
      this.notificationService
      .insertEnterpriseSettingUser(payload)
      .subscribe(
        (response) => {
          if(response.code == 200){
            this.alertService.showMessage(
              response.message,
              "",
              MessageSeverity.success
            );
            this.dialogRef.close({edit:true});
            
          }else{
            this.alertService.showMessage(
              response.message,
              "",
              MessageSeverity.error
            );
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }

    
  }
}
